import { clsx } from 'clsx';

const statusColors: Record<string, string> = {
  active: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  blocked: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  created: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  queued: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300',
  submitted: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-300',
  processing: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300',
  processed: 'bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300',
  input_required: 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300',
  pending: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  completed: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
  canceled: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
  failed: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  error: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  'cancel.submitted': 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  cancelsubmitted: 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  canceling: 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
  declined: 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300',
  withdrawn: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
  unknown: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400',
};

interface StatusBadgeProps {
  status: string;
  className?: string;
  tooltip?: string;
}

export default function StatusBadge({ status, className, tooltip }: StatusBadgeProps) {
  const color = statusColors[status] || 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
  return (
    <span className={clsx('badge', color, className)} title={tooltip}>
      {status.replace(/[._]/g, ' ')}
    </span>
  );
}
